<template>
  <nav v-if="$store.getters['auth/user']" class="mobile-nav" v-show="isMobile">
    <div class="nav-item" v-for="(item, index) in visibleItems" :key="index" @click="goTo(item.path)">
      <img :src="item.image" alt="" class="nav-icon">
      <span class="nav-label">{{ $ml.get(item.label) }}</span>
    </div>

    <div class="nav-item more-btn" @click="toggleMore">
      <span>⋯</span>
    </div>

    <div v-if="showMore" class="more-menu">
      <div class="more-item" v-for="(item, index) in hiddenItems" :key="index" @click="goTo(item.path)">
        <img :src="item.image" alt="" class="more-icon">
        <span>{{ $ml.get(item.label) }}</span>
      </div>

      <div class="menu-divider"></div>

      <div class="more-item wallet" @click="$router.push('/payment')">
        <img src="../assets/wallet.png" alt="wallet" class="more-icon">
        <Money :amount="$store.getters['auth/user'].balance" currency="EUR"/>
      </div>

      <div class="more-item theme" @click="toggleTheme">
        <p class="theme">{{ theme === 'dark' ? '🌙' : '☀️' }}</p>
        <p class="theme">{{ theme === 'dark' ? $ml.get('menu_theme_dark') : $ml.get('menu_theme_white') }}</p>
      </div>

      <div class="more-item logout" @click="logout">
        <img src="../assets/logout.png" alt="logout" class="more-icon">
        <span>{{ $ml.get('menu_logout') }}</span>
      </div>

      <div class="more-item languages">
        <a @click="$ml.change('ru')" title="Русский"><img src="../assets/ru.png"></a>
        <a @click="$ml.change('en')" title="English"><img src="../assets/en.png"></a>
      </div>
    </div>
  </nav>
</template>
<script>
import Money from "@/components/Money";
import {ThemeManager} from "../theme";

export default {
  name: 'BottomNav',
  components: {Money},
  data() {
    return {
      showMore: false,
      theme: ThemeManager.getTheme(),
      navItems: [
        { label: 'menu_main', path: '/', image: 'https://cloud.betexy.com/img/logo_s.20201ea5.svg' },
        { label: 'menu_dashboard', path: '/dashboard', image: 'https://ucarecdn.com/a6c7e67c-b052-4244-8528-53d7b94812ba/webdesign_5277589.png' },
        { label: 'menu_accounts', path: '/rooms', image: 'https://ucarecdn.com/b7ff5e55-f223-4cdc-81ef-c2105743b617/intermediary_4954391.png' },
        { label: 'menu_bets', path: '/bets/placed', image: 'https://ucarecdn.com/d6a12a37-8534-474a-aee7-02ad9f452937/hardware_4786014.png' },
        { label: 'menu_statistic', path: '/statistic/user', image: 'https://ucarecdn.com/edb3643c-f0a8-476d-b2d1-a34dd86d130d/pricelist_4954401.png' },
        { label: 'menu_strategies', path: '/public-strategies', image: 'https://ucarecdn.com/8121f0dc-d756-48bc-887b-bceac3e06913/strategy_7430600.png' },
        { label: 'titles_pages_help', path: '/pages/help', image: 'https://ucarecdn.com/66192747-6d5a-4d1a-90d3-a4d904a9e5e1/education_8262836.png' },
      ]
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768
    },
    visibleItems() {
      return this.navItems.slice(0, 4)
    },
    hiddenItems() {
      return this.navItems.slice(4)
    }
  },
  methods: {
    goTo(path) {
      this.$router.push(path)
      this.showMore = false
    },
    toggleMore() {
      this.showMore = !this.showMore
    },
    logout() {
      this.$store.dispatch('auth/logout')
    },
    toggleTheme() {
      this.theme = ThemeManager.toggleTheme()
    }
  },
  mounted() {
    ThemeManager.setTheme(this.theme)
  }
}
</script>

<style scoped>
.mobile-nav {
  position: fixed;
  bottom: 0;
  left: 0; right: 0;
  background: var(--bg-color);
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: space-around;
  padding: 10px 0;
  z-index: 1000;
}

.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  color: var(--text-color);
  cursor: pointer;
  transition: 0.2s;
}
.nav-item:hover { color: var(--accent-color, #007bff); }

.nav-icon {
  width: 22px;
  height: 22px;
}
.nav-label {
  margin-top: 2px;
  font-size: 11px;
}

.more-btn {
  font-size: 20px;
  font-weight: bold;
}

.more-menu {
  position: absolute;
  bottom: 60px;
  left: 10px; right: 10px;
  background: var(--bg-color);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  animation: slideUp 0.2s ease-out;
}

.more-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
  color: var(--text-color);
}

.theme{
  color: var(--text-color);
}

.more-item:hover {
  background: var(--bg-color);
}
.more-icon {
  width: 20px;
  height: 20px;
}

.menu-divider {
  height: 1px;
  background: #eee;
  margin: 4px 0;
}

.languages a img {
  width: 22px;
  margin: 0 4px;
}

@keyframes slideUp {
  from { transform: translateY(10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
</style>